(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["babafuchs-subscription-selector"] && !Shopify.designMode) return;
  try {
    if (!window.babaFuchsSubscriptionSelector) {
    const stateByForm = new Map();

    const selectorForForm = (formId) =>
      Array.from(document.querySelectorAll('[data-bf-subscription]')).find(
        (selector) => selector.dataset.bfSubscriptionForm === formId,
      );

    const applyState = (selector, requestedMode, requestedPlanId) => {
      const modes = Array.from(selector.querySelectorAll('[data-bf-subscription-mode]'));
      const oneTimeMode = modes.find((mode) => mode.value === 'one-time');
      const subscriptionMode = modes.find((mode) => mode.value === 'subscription');
      const panel = selector.querySelector('[data-bf-subscription-panel]');
      const select = selector.querySelector('[data-bf-subscription-select]');
      const price = selector.querySelector('[data-bf-subscription-price]');
      const unitPrice = selector.querySelector('[data-bf-subscription-unit-price]');
      const productPriceScope = selector.closest('product-rerender') || document;
      const productBasePrice = productPriceScope.querySelector('[data-bf-product-base-price]');
      const productPlanPrice = productPriceScope.querySelector('[data-bf-product-plan-price]');
      const productPlanTotal = productPriceScope.querySelector('[data-bf-product-plan-total]');
      const productPlanCompare = productPriceScope.querySelector('[data-bf-product-plan-compare]');
      const productPlanUnit = productPriceScope.querySelector('[data-bf-product-plan-unit]');
      const formId = selector.dataset.bfSubscriptionForm;
      const requestedOption = Array.from(select?.options || []).find(
        (option) => option.value === String(requestedPlanId || ''),
      );
      const requestedPlanUnavailable =
        requestedMode === 'subscription' &&
        requestedPlanId != null &&
        String(requestedPlanId) !== '' &&
        !requestedOption;
      const subscriptionSelected =
        requestedMode === 'subscription' &&
        select?.options.length > 0 &&
        !requestedPlanUnavailable;

      if (oneTimeMode) oneTimeMode.checked = !subscriptionSelected;
      if (subscriptionMode) {
        subscriptionMode.checked = subscriptionSelected;
      }

      panel.hidden = !subscriptionSelected;
      select.disabled = !subscriptionSelected;

      if (subscriptionSelected) {
        select.value = requestedOption?.value || select.options[0].value;
        price.textContent = select.selectedOptions[0]?.dataset.price || price.textContent;
        unitPrice.textContent = select.selectedOptions[0]?.dataset.unitPrice || '';
        unitPrice.hidden = !unitPrice.textContent;
      }

      const selectedOption = select?.selectedOptions[0];

      if (productBasePrice && productPlanPrice) {
        productBasePrice.hidden = subscriptionSelected;
        productPlanPrice.hidden = !subscriptionSelected;

        if (subscriptionSelected) {
          productPlanTotal.textContent = selectedOption?.dataset.price || '';
          productPlanCompare.textContent = selectedOption?.dataset.comparePrice || '';
          productPlanCompare.closest('compare-at-price').hidden = !productPlanCompare.textContent;
          productPlanUnit.textContent = selectedOption?.dataset.unitPrice || '';
          productPlanUnit.hidden = !productPlanUnit.textContent;
        }
      }

      const sticky = Array.from(document.querySelectorAll('product-sticky-add-to-cart')).find(
        (element) => element.getAttribute('main-product-form') === formId,
      );
      const stickyBasePrice = sticky?.querySelector('[data-bf-sticky-base-price]');
      const stickyPlanPrice = sticky?.querySelector('[data-bf-sticky-plan-price]');
      const stickyPlanTotal = sticky?.querySelector('[data-bf-sticky-plan-total]');
      const stickyPlanCompare = sticky?.querySelector('[data-bf-sticky-plan-compare]');
      const stickyPlanUnit = sticky?.querySelector('[data-bf-sticky-plan-unit]');

      if (stickyBasePrice && stickyPlanPrice) {
        stickyBasePrice.hidden = subscriptionSelected;
        stickyPlanPrice.hidden = !subscriptionSelected;

        if (subscriptionSelected) {
          stickyPlanTotal.textContent = selectedOption?.dataset.price || '';
          stickyPlanCompare.textContent = selectedOption?.dataset.comparePrice || '';
          stickyPlanCompare.closest('compare-at-price').hidden = !stickyPlanCompare.textContent;
          stickyPlanUnit.textContent = selectedOption?.dataset.unitPrice || '';
          stickyPlanUnit.hidden = !stickyPlanUnit.textContent;
        }
      }

      if (formId) {
        stateByForm.set(formId, {
          mode: subscriptionSelected ? 'subscription' : 'one-time',
          planId: subscriptionSelected ? select.value : null,
        });
      }
    };

    const rememberCurrentState = (selector) => {
      const mode = selector.querySelector('[data-bf-subscription-mode]:checked');
      const select = selector.querySelector('[data-bf-subscription-select]');
      applyState(selector, mode?.value || 'one-time', select?.value);
    };

    window.babaFuchsSubscriptionSelector = { stateByForm };

    document.querySelectorAll('[data-bf-subscription]').forEach(rememberCurrentState);

    document.addEventListener('change', (event) => {
      const selector = event.target.closest('[data-bf-subscription]');

      if (!selector) {
        return;
      }

      rememberCurrentState(selector);
    });

    document.addEventListener('variant:change', (event) => {
      const eventFormId = event.detail?.formId;
      const formId =
        typeof eventFormId === 'string'
          ? eventFormId
          : event.target?.getAttribute?.('id');
      const previousState = formId ? stateByForm.get(formId) : null;

      if (!previousState) return;

      queueMicrotask(() => {
        const selector = selectorForForm(formId);

        if (selector) {
          applyState(selector, previousState.mode, previousState.planId);
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!window.babaFuchsStickyAddToCartSync) {
    let frameId = null;
    const mobileQuery = window.matchMedia('(max-width: 699px)');
    const observedElements = new Set();
    const layoutObserver = new ResizeObserver(() => scheduleStickyAddToCartSync());

    const observeLayout = (element) => {
      if (!element || observedElements.has(element)) return;
      observedElements.add(element);
      layoutObserver.observe(element);
    };

    const syncStickyAddToCart = () => {
      frameId = null;
      observedElements.forEach((element) => {
        if (element.isConnected) return;
        layoutObserver.unobserve(element);
        observedElements.delete(element);
      });

      const footer = document.querySelector('.shopify-section--footer');
      observeLayout(document.body);
      observeLayout(footer);

      document.querySelectorAll('product-sticky-add-to-cart').forEach((sticky) => {
        const formId = sticky.getAttribute('main-product-form');
        const form = formId ? document.getElementById(formId) : null;
        observeLayout(form);

        if (!mobileQuery.matches || !form || form.hidden || form.getClientRects().length === 0) {
          sticky.classList.remove('bf-is-visible');
          return;
        }

        const formRect = form.getBoundingClientRect();
        const footerRect = footer?.getBoundingClientRect();
        const footerIsVisible = footerRect
          ? footerRect.top < window.innerHeight && footerRect.bottom > 0
          : false;

        sticky.classList.toggle('bf-is-visible', formRect.bottom <= 0 && !footerIsVisible);
      });
    };

    const scheduleStickyAddToCartSync = () => {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(syncStickyAddToCart);
    };

    window.babaFuchsStickyAddToCartSync = { schedule: scheduleStickyAddToCartSync };
    document.addEventListener('scroll', scheduleStickyAddToCartSync, { passive: true });
    window.addEventListener('resize', scheduleStickyAddToCartSync, { passive: true });
    document.addEventListener('variant:change', scheduleStickyAddToCartSync);
    document.addEventListener('shopify:section:load', scheduleStickyAddToCartSync);
    document.addEventListener('shopify:section:unload', scheduleStickyAddToCartSync);
    mobileQuery.addEventListener?.('change', scheduleStickyAddToCartSync);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleStickyAddToCartSync, { once: true });
    } else {
      scheduleStickyAddToCartSync();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
